import {
  GET_CHECK_HANDS_DATA,
  GET_CHECK_HANDS_DATA_SUCCESS,
  GET_CHECK_HANDS_DATA_FAILURE,
} from './checkHandsActions';

// Handlers
export const handleCheckHandsDataRequest = (state) => {
  return {
    ...state,
    checkHandsLoading: true,
  };
};

export const handleCheckHandsDataSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      checkHandsLoading: false,
      checkHandsData: data.data,
    };
  }
  return {
    ...state,
    checkHandsLoading: false,
  };
};

export const handleCheckHandsDataFailure = (state, action) => {
  return {
    ...state,
    checkHandsLoading: false,
    checkHandsError: action.payload.error,
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [GET_CHECK_HANDS_DATA]: handleCheckHandsDataRequest,
  [GET_CHECK_HANDS_DATA_SUCCESS]: handleCheckHandsDataSuccess,
  [GET_CHECK_HANDS_DATA_FAILURE]: handleCheckHandsDataFailure,
};

// Initial state
const initialState = {
  checkHandsLoading: false,
  checkHandsData: null,
  checkHandsError: null,
};

export default function checkHandsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}